import SessionActionTypeEnum from 'FormSwiftAPI/Session/SessionConstants';
import * as Store from 'store';
import * as SessionSaveUtils from './SessionSaveUtils';
import { gracefulSave } from './SessionActions';

export const stopAutoSave = () => (
  (dispatch) => {
    dispatch({ type: SessionActionTypeEnum.STOP_AUTO_SAVE });
  }
);

export const autoSave = (getSavingFuncArgs, savingFunc, unsubscribe) => (
  async (dispatch, getState) => {
    const { SessionHandler } = getState().FormSwiftAPIHandler;

    // only save if autosave enabled
    if (!SessionHandler.isAutoSavingEnabled) {
      unsubscribe();
      return;
    }

    // verify that what were saving is different from last successful save
    const savingArgs = dispatch(getSavingFuncArgs());

    if (SessionHandler.lastAutoSaveValue === JSON.stringify(savingArgs)) {
      return;
    }

    await dispatch(gracefulSave(savingFunc, savingArgs));
  }
);

export const startGracefulAutoSave = (
  getSavingFuncArgs,
  savingFunc,
  initialAutoSaveValue,
  time = 3000,
) => (
  (dispatch) => {
    dispatch({
      type: SessionActionTypeEnum.SET_SESSION_AUTO_SAVE_VALUE,
      autoSaveValue: initialAutoSaveValue,
    });

    dispatch({ type: SessionActionTypeEnum.START_AUTO_SAVE });
    const unsubscribe = Store.getStore().subscribe(
      SessionSaveUtils.throttleSave(
        time,
        () => dispatch(autoSave(getSavingFuncArgs, savingFunc, unsubscribe)),
      ),
    );
  }
);



// WEBPACK FOOTER //
// ./src-react/FormSwiftAPI/Session/SessionAutoSaveActions.jsx